var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1786_1331",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1786_1331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0008 30.4575L12.5285 34.9575C12.2785 35.1149 12.0146 35.1843 11.7368 35.1658C11.4591 35.1473 11.2137 35.0594 11.0008 34.9019C10.7878 34.7445 10.6257 34.5431 10.5146 34.2978C10.4035 34.0524 10.3804 33.777 10.4452 33.4714L12.4174 24.9575L5.82017 19.2214C5.57945 19.0084 5.43362 18.77 5.38267 18.5061C5.33176 18.2422 5.34334 17.9853 5.41742 17.7353C5.49148 17.4853 5.63037 17.2769 5.83409 17.1103C6.03778 16.9436 6.29703 16.8417 6.61184 16.8047L15.3341 16.0408L18.7091 8.01302C18.8295 7.73524 19.0123 7.52691 19.2577 7.38802C19.5031 7.24913 19.7508 7.17969 20.0008 7.17969C20.2508 7.17969 20.4984 7.24913 20.7438 7.38802C20.9892 7.52691 21.1721 7.73524 21.2924 8.01302L24.6674 16.0408L33.3897 16.8047C33.7045 16.8417 33.9637 16.9436 34.1674 17.1103C34.3711 17.2769 34.51 17.4853 34.5841 17.7353C34.6582 17.9853 34.6698 18.2422 34.6188 18.5061C34.5679 18.77 34.4221 19.0084 34.1813 19.2214L27.5841 24.9575L29.5563 33.4714C29.6211 33.777 29.598 34.0524 29.4869 34.2978C29.3758 34.5431 29.2137 34.7445 29.0008 34.9019C28.7878 35.0594 28.5424 35.1473 28.2647 35.1658C27.9869 35.1843 27.723 35.1149 27.473 34.9575L20.0008 30.4575Z",
    fill: "#995D30"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.968fbd464b6a2e38833ad169a2d54608.svg";
export { ForwardRef as ReactComponent };